import { useEffect } from "react";
import { Button, Modal } from "react-bootstrap"
import { ColorPicker, toColor, useColor } from "react-color-palette";

import "react-color-palette/lib/css/styles.css";

interface IProps {
    show: boolean,
    employee: string,
    backgroundColor: string,
    color: string,
    onDone: (backgroundColor: string, color: string) => void,
    onCancel: () => void
}

const ColorSelector = (props: IProps) => {
    const [backgroundColor, setBackgroundColor] = useColor('hex', props.backgroundColor);
    const [color, setColor] = useColor('hex', props.color);

    const handleDone = () => {
        props.onDone(backgroundColor.hex, color.hex);
    };

    useEffect(() => {
        if (props.show) {
            setBackgroundColor(toColor('hex', props.backgroundColor));
            setColor(toColor('hex', props.color));
        }
    }, [props.show])

    return (
        <Modal bsSize='sm' backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Select Color for {props.employee}</Modal.Header>
            <Modal.Body>
                <div>
                    <div style={{ marginBottom: 20 }}>
                        Background Color:
                        <ColorPicker width={267} height={208} color={backgroundColor} onChange={setBackgroundColor} hideHSV hideRGB hideHEX />
                        Text Color:
                        <ColorPicker width={267} height={208} color={color} onChange={setColor} hideHSV hideRGB hideHEX />
                    </div>
                    <div>
                        Preview: <span style={{ padding: '10px 20px', backgroundColor: backgroundColor.hex, color: color.hex }}>{props.employee}</span>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleDone}>Done</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ColorSelector;